import { preventDefault } from "@frui.ts/views";
import Button from "@edaz/edazkit/Button";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import React from "react";
import { observer } from "mobx-react-lite";
import { ButtonToolbar, Form } from "react-bootstrap";
import type CreateViewModel from "../../viewModels/createViewModel";

export interface CreateViewProps<TEntity> {
  vm: CreateViewModel<TEntity>;
  form: React.ReactElement;
  titleClassName?: string;
  customButtonClassName?: string;
  customAddText?: string;
  customCancelText?: string;
  hideTitle?: boolean;
}

function CreateView<TEntity>(props: CreateViewProps<TEntity>) {
  const { vm, form, hideTitle, titleClassName, customAddText, customCancelText, customButtonClassName } = props;

  return (
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      {!hideTitle && <h3 className={titleClassName ?? "text-center"}>{vm.translate("create")}</h3>}
      <Form onSubmit={preventDefault(vm.create)}>
        {form}
        <ButtonToolbar className="justify-content-center">
          <Button className={customButtonClassName} size="sm" onClick={vm.cancel} type="reset" variant="light">
            {customCancelText ? vm.translateGeneral(customCancelText) : vm.translateGeneral("cancel")}
          </Button>
          <Button className={customButtonClassName} size="sm" type="submit" disabled={!vm.canSave}>
            {customAddText ? vm.translateGeneral(customAddText) : vm.translateGeneral("add")}
          </Button>
        </ButtonToolbar>
      </Form>
    </LoaderOverlay>
  );
}

export default observer(CreateView);
